module.exports = __webpack_public_path__ + "img/banner.28100751.png";